import React from 'react';
import styles from './NavIcons.module.css';
import InstagramIcon from '../../Icons/InstagramIcon';
import FacebookIcon from '../../Icons/FacebookIcon';
import WhatsAppIcon from '../../Icons/WhatsAppIcon';

const navIconsInfo = [
  {
    link: 'https://www.instagram.com/vikyvivavi/',
    icon: <InstagramIcon />,
  },
  {
    link: 'https://www.facebook.com/viktoriia.perfilieva',
    icon: <FacebookIcon />,
  },
  {
    link: '#',
    icon: <WhatsAppIcon />,
  },
];

const NavIcons = () => {
  return (
    <div className={styles.socialIcons}>
      {navIconsInfo?.map((item, idx) => (
        <a
          key={idx}
          href={item.link}
          target="_blank"
          rel="noreferrer"
          className={styles.socialIcon}
        >
          {item.icon}
        </a>
      ))}
      {/* <a
        href="https://www.facebook.com/viktoriia.perfilieva"
        className={styles.socialIcon}
      >
        <FacebookIcon />
      </a>
      <a href="#" className={styles.socialIcon}>
        <WhatsAppIcon />
      </a> */}
    </div>
  );
};

export default NavIcons;
